// Enhanced fullscreen detection with vendor prefixes
export const getFullscreenElement = () => {
  return (
    document.fullscreenElement ||
    (document as any).webkitFullscreenElement ||
    (document as any).mozFullScreenElement ||
    (document as any).msFullscreenElement
  );
};

export const getFullscreenMethod = () => {
  const docEl = document.documentElement as any;
  
  if (docEl.requestFullscreen) return docEl.requestFullscreen.bind(docEl);
  if (docEl.webkitRequestFullscreen) return docEl.webkitRequestFullscreen.bind(docEl);
  if (docEl.mozRequestFullScreen) return docEl.mozRequestFullScreen.bind(docEl);
  if (docEl.msRequestFullscreen) return docEl.msRequestFullscreen.bind(docEl);
  
  return null;
};

export const getExitFullscreenMethod = () => {
  const doc = document as any;
  
  if (doc.exitFullscreen) return doc.exitFullscreen.bind(doc);
  if (doc.webkitExitFullscreen) return doc.webkitExitFullscreen.bind(doc);
  if (doc.mozCancelFullScreen) return doc.mozCancelFullScreen.bind(doc);
  if (doc.msExitFullscreen) return doc.msExitFullscreen.bind(doc);
  
  return null;
};